import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../../../Components/Common/ChartsDynamicColor";
import TableService from "../../../../services/OrderingServices/TableService";
import { Card, CardBody, CardHeader } from "reactstrap";

const TablePieChart = () => {
  const [countData, setCountData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStatusCount = async () => {
      setLoading(true);
      try {
        const response = await TableService.getStatusCount();
        const filteredData = response.filter(
          (item) => item.status !== "Unavailable"
        );
        setCountData(filteredData);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchStatusCount();
  }, []);

  const getTotalCount = () => {
    if (!countData) return 0;
    return countData.reduce((total, item) => total + item.count, 0);
  };

  const labels = countData ? countData.map((item) => item.status) : [];
  const series = countData ? countData.map((item) => item.count) : [];
  const dataColors =
    '["--vz-success", "--vz-dark", "--vz-danger", "--vz-warning"]';
  const chartDonutBasicColors = getChartColorsArray(dataColors);
  const tableText = (count) => `${count} table${count === 1 ? "" : "s"}`;

  const options = {
    labels: labels,
    chart: {
      height: 280,
      type: "donut",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: "14px",
              fontWeight: 500,
              offsetY: -5,
            },
value: {
  show: true,
  fontSize: "24px",
  fontWeight: 700,
  offsetY: 5,
  formatter: function (val) {
    return tableText(val);
  },
},

            total: {
              show: true,
              label: "Total Tables",
              fontSize: "12px",
              fontWeight: 500,
              color: "#6c757d",
              formatter: function (w) {
                return getTotalCount();
              },
            },
          },
        },
      },
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      fontSize: "13px",
      fontWeight: 500,
      offsetY: 5,
      markers: {
        width: 10,
        height: 10,
        radius: 2,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 5,
      },
    },
    stroke: {
      show: false,
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "12px",
        fontWeight: 600,
      },
      dropShadow: {
        enabled: false,
      },
      formatter: function (val, opts) {
        return opts.w.config.series[opts.seriesIndex];
      },
    },
    colors: chartDonutBasicColors,
    tooltip: {
      y: {
        formatter: function (val) {
          return tableText(val);
        },
      },
    },
  };

  if (loading) {
    return (
      <Card className="border-0 shadow-sm">
        <CardHeader className="border-0 bg-transparent">
          <h5 className="mb-0 fw-semibold">Tables Summary</h5>
        </CardHeader>
        <CardBody className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card className="" style={{ minHeight: "335px", borderRadius: "1rem" }}>
      <CardHeader className="border-0 bg-transparent pb-0">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0 fw-semibold">Tables Summary</h5>
          {/* <div 
            className="px-2 py-1 rounded-pill align-content-center text-center"
            style={{
              backgroundColor: "#f0f7ff",
              fontSize: "0.65rem",
              fontWeight: 600,
              color: "#0066cc",
            }}
          >
            <i className="ri-table-line me-1"></i>
            {getTotalCount()} Total
          </div> */}
        </div>
      </CardHeader>
      <CardBody className="px-3 pt-2 pb-1">
        {countData && countData.length > 0 ? (
          <>
            <ReactApexChart
              dir="ltr"
              options={options}
              series={series}
              type="donut"
              height="280"
              className="apex-charts"
            />
          </>
        ) : (
          <div className="text-center py-5">
            <i
              className="ri-table-line text-muted mb-3"
              style={{ fontSize: "2.5rem" }}
            ></i>
            <p className="text-muted mb-0">No table data available</p>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default TablePieChart;
